const fallbackMessages = {
  beforeNoon: "Voor 12:00 u. besteld, vandaag verzonden",
  tomorrow: "Vandaag besteld, morgen verzonden",
  onDate: "Vandaag besteld, {date} verzonden",
};

export function getShippingDate({
  now = new Date(),
  t = (key, parameters = {}) => {
    const message = fallbackMessages[key.split(".").at(-1)] || key;
    return message.replace("{date}", parameters.date || "");
  },
  formatDate = formatDateNL,
} = {}) {
  // return `Vandaag besteld, morgen verzonden`;
  const hour = now.getHours();
  const day = now.getDay(); // 0 = zondag, 1 = maandag, ..., 6 = zaterdag

  const isWeekday = day >= 1 && day <= 5;
  const isBeforeNoon = hour < 12;

  // Haal jaar op voor dynamische feestdagen
  const year = now.getFullYear();

  // Voeg vaste én variabele Nederlandse feestdagen toe
  const holidays = getDutchHolidays(year).map((date) => date.toDateString());

  // Helper: check of datum een werkdag én géén feestdag is
  function isValidShippingDay(date) {
    const day = date.getDay();
    return day >= 1 && day <= 5;
    // return day >= 1 && day <= 5 && !holidays.includes(date.toDateString());
  }

  // Case 1: Voor 12:00 uur op werkdag én geen feestdag → vandaag verzenden
  if (isWeekday && isBeforeNoon && isValidShippingDay(now)) {
    return t("shipping.beforeNoon");
  }

  // Case 2: Na 12:00 uur op ma-do of op zondag → morgen verzenden (indien werkdag en geen feestdag)
  if ((isWeekday && day !== 5) || day === 0) {
    const morgen = new Date(now);
    morgen.setDate(now.getDate() + 1);
    while (!isValidShippingDay(morgen)) {
      morgen.setDate(morgen.getDate() + 1);
    }
    return t("shipping.tomorrow");
  }

  // Case 3: Vrijdag na 12:00 of zaterdag → verzenden op eerstvolgende geldige werkdag
  const verzendDatum = new Date(now);
  do {
    verzendDatum.setDate(verzendDatum.getDate() + 1);
  } while (!isValidShippingDay(verzendDatum));

  return t("shipping.onDate", {
    date: formatDate(verzendDatum, {
      weekday: "long",
      day: "numeric",
      month: "long",
    }),
  });
}

// ✅ Hulp: formaat "maandag 6 mei"
function formatDateNL(date) {
  const dagen = [
    "zondag",
    "maandag",
    "dinsdag",
    "woensdag",
    "donderdag",
    "vrijdag",
    "zaterdag",
  ];
  const maanden = [
    "januari",
    "februari",
    "maart",
    "april",
    "mei",
    "juni",
    "juli",
    "augustus",
    "september",
    "oktober",
    "november",
    "december",
  ];
  return `${dagen[date.getDay()]} ${date.getDate()} ${
    maanden[date.getMonth()]
  }`;
}

// ✅ Hulp: lijst met Nederlandse feestdagen (inclusief variabele)
function getDutchHolidays(year) {
  const holidays = [];

  // Vaste feestdagen
  holidays.push(new Date(year, 0, 1)); // Nieuwjaarsdag
  holidays.push(new Date(year, 4, 27)); // Koningsdag
  holidays.push(new Date(year, 11, 25)); // Eerste Kerstdag
  holidays.push(new Date(year, 11, 26)); // Tweede Kerstdag

  // Variabele feestdagen via Paasdatum
  const easter = getEasterDate(year);
  const addDays = (base, days) =>
    new Date(base.getFullYear(), base.getMonth(), base.getDate() + days);

  holidays.push(easter); // Eerste Paasdag
  holidays.push(addDays(easter, 1)); // Tweede Paasdag
  holidays.push(addDays(easter, 39)); // Hemelvaart
  holidays.push(addDays(easter, 49)); // Pinksteren
  holidays.push(addDays(easter, 50)); // Tweede Pinksterdag

  return holidays;
}

// ✅ Bereken Paasdatum (Computus-algoritme)
function getEasterDate(year) {
  const f = Math.floor,
    G = year % 19,
    C = f(year / 100),
    H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30,
    I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11)),
    J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
    L = I - J,
    month = 3 + f((L + 40) / 44),
    day = L + 28 - 31 * f(month / 4);
  return new Date(year, month - 1, day);
}
